import { clearError } from "../../../../error";
import { clearNewSearch, setNewSearch } from "../../store/actionCreators";

const undoSearch = () => (dispatch) => {
  dispatch(clearNewSearch());
  dispatch(clearError());
  dispatch(setNewSearch());
};

export default undoSearch;
